import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalActions from 'Modals/ModalActions';
import store from 'store';


const connectModal = (WrappedComponent, elmId, props = {}) => {
  const mapStateToProps = state => ({
    activeModal: state.ModalHandler.activeModal,
    finalStep: state.ModalHandler.finalStep,
    additionalData: state.ModalHandler.additionalData,
  });

  const mapDispatchToProps = dispatch => (
    bindActionCreators({
      ...ModalActions,
    }, dispatch)
  );

  const ConnectedWrappedComponent = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WrappedComponent);

  class ModalContainer extends React.Component {
    static init(additionalData, id = null) {
      const elementId = id || elmId;
      const properties = Object.assign({}, props, additionalData);

      ReactDOM.render(
        <ReactRedux.Provider store={store}>
          <ModalContainer {...properties} />
        </ReactRedux.Provider>,
        document.getElementById(elementId),
      );
    }

    render() {
      return (
        <div>
          <ConnectedWrappedComponent {...this.props} >
            {this.props.children &&
              this.props.children
            }
          </ConnectedWrappedComponent>
        </div>
      );
    }
  }

  ModalContainer.defaultProps = {
    children: null,
  };

  ModalContainer.propTypes = {
    children: PropTypes.node,
  };

  return ModalContainer;
};


if (window.FormSwift && window.FormSwift.React) {
  const newActions = Object.assign(
    {},
    window.FormSwift.React.actions,
    ModalActions,
  );
  window.FormSwift.React.actions = newActions;
} else {
  window.FormSwift = {
    React: {
      store,
      actions: ModalActions,
    },
  };
}

export default connectModal;



// WEBPACK FOOTER //
// ./src-react/Modals/enhancers/ConnectModal.jsx